import React from 'react';
import { Edit, Copy, Eye, FileText } from 'lucide-react';
import useAssessmentManagementStore from '@/stores/AdminStore/AssessmentManagementStore';
import './AssessmentList.css';

const AssessmentList: React.FC = () => {
  const { assessments } = useAssessmentManagementStore();

  return (
    <div className="trainer-assessment-list">
      <div className="trainer-assessment-cards-grid">
        {assessments?.map((assessment) => (
          <div key={assessment.id} className="trainer-assessment-card">
            <div className="trainer-assessment-card-header">
              <div className="trainer-assessment-icon-wrapper">
                <FileText size={32} />
              </div>
              <span className="trainer-assessment-status-badge">
                {assessment.status}
              </span>
            </div>

            <h3 className="trainer-assessment-card-title">{assessment.name}</h3>
            <p className="trainer-assessment-card-description">{assessment.description}</p>

            <div className="trainer-assessment-card-details">
              <div className="trainer-assessment-detail-row">
                <span className="trainer-assessment-detail-label">Type:</span>
                <span className="trainer-assessment-detail-value">{assessment.type}</span>
              </div>
              <div className="trainer-assessment-detail-row">
                <span className="trainer-assessment-detail-label">Questions:</span>
                <span className="trainer-assessment-detail-value">{assessment.questions}</span>
              </div>
              <div className="trainer-assessment-detail-row">
                <span className="trainer-assessment-detail-label">Time:</span>
                <span className="trainer-assessment-detail-value">{assessment.time}</span>
              </div>
              <div className="trainer-assessment-detail-row">
                <span className="trainer-assessment-detail-label">Passing:</span>
                <span className="trainer-assessment-detail-value">{assessment.passing}</span>
              </div>
            </div>

            <div className="trainer-assessment-card-actions">
              <button className="trainer-assessment-action-btn trainer-copy">
                <Copy size={18} />
              </button>
              <button className="trainer-assessment-action-btn trainer-view">
                <Eye size={18} />
                View
              </button>
              <button className="trainer-assessment-action-btn trainer-edit">
                <Edit size={18} />
                Edit
              </button>
            </div>

            <div className="trainer-assessment-card-footer">
              Created {assessment.created}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssessmentList;
